import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PanelLayout from './components/panel/PanelLayout';
import Login from './pages/panel/Login';
import Dashboard from './pages/panel/Dashboard';
import Logs from './pages/panel/Logs';
import Consultas from './pages/panel/Consultas';
import Clientes from './pages/panel/Clientes';
import ConsultaMultasPanel from './pages/panel/ConsultaMultasPanel';
import ConsultasAPI from './pages/panel/ConsultasAPI';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App">
          <Routes>
            {/* Ruta pública - redirige al panel */}
            <Route path="/" element={<Navigate to="/panel" replace />} />
            <Route path="*" element={<Navigate to="/panel" replace />} />

            {/* Ruta de login del panel */}
            <Route path="/panel/login" element={<Login />} />

            {/* Rutas protegidas del panel */}
            <Route
              path="/panel"
              element={
                <ProtectedRoute>
                  <PanelLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="logs" element={<Logs />} />
              <Route path="consultas" element={<Consultas />} />
              <Route path="clientes" element={<Clientes />} />
              <Route path="consulta-multas" element={<ConsultaMultasPanel />} />
              <Route path="consultas-api" element={<ConsultasAPI />} />
            </Route>
          </Routes>
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
